module.exports = __webpack_public_path__ + "img/FotoMo4.95aafe38.png";